<template>
    <el-dialog title="配置规则" :visible.sync="configurationRulesVisible" width="70%" :close-on-click-modal="false">
        <el-form ref="addConfigurationRef" label-suffix="：" label-width="150px" :model="configurationRulesForm"
            :rules="configurationRulesRules" size="small">
            <el-form-item label="不符合标签的患者" prop="unbind">
                <el-radio-group v-model="configurationRulesForm.unbind">
                    <el-radio :label="1">移除标签</el-radio>
                    <el-radio :label="2">不移除标签</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否自动更新" prop="method">
                <el-radio-group v-model="configurationRulesForm.method">
                    <el-radio :label="1">手动</el-radio>
                    <el-radio :label="2">自动</el-radio>
                </el-radio-group>
            </el-form-item>
            <div class="rules-select-all" v-if="canEdit">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                    @change="handleCheckAllChange">全选</el-checkbox>
                <span>
                    <el-button type="primary" size="small" :disabled="selectRuleList.length <= 0"
                        @click="handleDeleteClick">批量删除</el-button>
                    <el-button type="primary" size="small" :disabled="selectRuleList.length <= 0"
                        @click="handleCopyClick">复制</el-button>
                </span>
            </div>
            <!-- 规则列表 -->
            <div v-for="(item, index) in configurationRulesForm.ruleInfoList" :key="index" :id="`ruleInfo${index}`">
                <div class="rules-header">
                    <el-checkbox v-if="canEdit" :value="selectRuleList.indexOf(item.key) >= 0"
                        @change="handleCheckChange($event, item)"></el-checkbox>
                    <span style="font-size: 20px; margin-left: 5px; cursor: pointer;" @click="addSignToLogic1(item)">
                        {{ `规则${index + 1}` }}
                    </span>
                    <p class="dashed-line"></p>
                    <el-button v-if="canEdit && configurationRulesForm.ruleInfoList.length > 1" type="text"
                        icon="el-icon-delete" @click="deleteRulesClick(index, item)"></el-button>
                </div>
                <div class="rules-item">
                    <el-form-item label="规则名称" :prop="'ruleInfoList.' + index + '.name'"
                        :rules="[{ required: true, message: '请输入规则名称', trigger: 'blur' }]">
                        <el-input style="width: 100%" v-model="item.name" placeholder="请输入规则名称" clearable
                            :disabled="!canEdit"></el-input>
                    </el-form-item>
                    <el-form-item label="规则属性" :prop="'ruleInfoList.' + index + '.labelRuleCategoryId'"
                        :rules="[{ required: true, message: '请选择规则属性', trigger: 'change' }]">
                        <el-select style="width: 100%" v-model="item.labelRuleCategoryId" placeholder="请选择规则属性"
                            :disabled="!canEdit" @change="ruleCategoryChange($event, index)">
                            <el-option v-for="item1 in rulePropertyList" :key="item1.id" :label="item1.name"
                                :value="item1.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 属性列表  选完上面的规则属性 才显示属性列表 -->
                    <div class="rules-content" v-if="item.labelRuleCategoryId">
                        <div class="rules-content-item" v-for="(metadataItem, j) in item.ruleMetadataInfoList" :key="j">
                            <div style="display: flex; flex-direction: row;">
                                <!-- 属性值 -->
                                <el-form-item :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.metadataId`"
                                    :rules="[{ required: true, message: '请选择属性值', trigger: 'change' }]">
                                    <template slot="label">
                                        <span @click="addSignToLogic(`${metadataItem.ruleKeyName} `, index)"
                                            style="cursor: pointer;">
                                            {{ metadataItem.ruleKeyName }}
                                        </span>
                                    </template>
                                    <el-select style="width: 140px" v-model="metadataItem.metadataId"
                                        placeholder="请选择属性值" clearable :disabled="!canEdit"
                                        @change="ruleMetadataChange($event, index, j)">
                                        <el-option v-for="item1 in item.ruleMetadataList" :key="item1.id"
                                            :label="item1.name" :value="item1.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <template v-if="metadataItem.metadataId">
                                    <!-- boolean 布尔类型-->
                                    <el-form-item label-width="10px" v-if="metadataItem.dataType == 'L'"
                                        :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.valueLower`"
                                        :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                                        <el-select style="width: 170px;" v-model="metadataItem.valueLower" class="s-2"
                                            :disabled="!canEdit">
                                            <el-option v-for="booleanItem in metadataValueListBoolean"
                                                :key="booleanItem.id" :label="booleanItem.name"
                                                :value="booleanItem.name"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!-- S3 枚举类型-->
                                    <template v-if="metadataItem.dataType == 'S3'">
                                        <el-form-item label-width="10px"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.predicateLower`"
                                            :rules="[{ required: true, message: '请选择判断关系', trigger: 'change' }]">
                                            <el-select v-model="metadataItem.predicateLower"
                                                :style="{ width: relationshipWidth }" placeholder="判断关系"
                                                :disabled="!canEdit">
                                                <el-option v-for="enumItem in enumSign" :key="enumItem.id"
                                                    :label="enumItem.name" :value="enumItem.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label-width="10px"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.valueLower`"
                                            :rules="[{ required: true, message: '请选择值', trigger: 'change' }]">
                                            <el-select v-model="metadataItem.valueLower" style="width: 250px;"
                                                placeholder="请选择" filterable :reserve-keyword="false" multiple
                                                :disabled="!canEdit">
                                                <el-option v-for="ele in metadataItem.enumList" :key="ele.id"
                                                    :label="ele.name" :value="ele.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                    <!-- 时间轴 -->
                                    <template v-if="metadataItem.dataType.includes('D')">
                                        <el-form-item label-width="10px"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.timeType`"
                                            :rules="[{ required: true, message: '请选择时间轴', trigger: 'change' }]">
                                            <el-select v-model="metadataItem.timeType"
                                                :style="{ width: relationshipWidth }" placeholder="时间轴"
                                                :disabled="!canEdit" @change="changeTimeType($event, index, j)">
                                                <el-option v-for="timeItem in timeAxis" :key="timeItem.id"
                                                    :label="timeItem.name" :value="timeItem.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <!-- 相对时间 近几天 -->
                                        <el-form-item label-width="10px" v-if="metadataItem.timeType == 2"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.recent`"
                                            :rules="[{ required: true, message: '请输入', trigger: 'change' }]">
                                            <div class="flex">
                                                <span>近</span>
                                                <el-input style="margin:0 10px;width:120px;"
                                                    v-model="metadataItem.recent" placeholder="请输入"
                                                    :disabled="!canEdit"></el-input>
                                                <span>天</span>
                                            </div>
                                        </el-form-item>
                                        <!-- 绝对时间 开始时间-结束时间 -->
                                        <el-form-item label-width="10px" v-if="metadataItem.timeType == 1"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.time`"
                                            :rules="[{ required: true, message: '请选择时间', trigger: 'change' }]">
                                            <el-date-picker style="width:250px" v-model="metadataItem.time"
                                                type="daterange" range-separator="-" start-placeholder="开始时间"
                                                end-placeholder="结束时间" format="yyyy/MM/dd" value-format="yyyy-MM-dd"
                                                :disabled="!canEdit"></el-date-picker>
                                        </el-form-item>
                                    </template>
                                    <!-- 数值 -->
                                    <template v-if="metadataItem.dataType.includes('N')">
                                        <el-form-item label-width="10px"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.predicateLower`"
                                            :rules="[{ required: true, message: '请选择判断关系', trigger: 'change' }]">
                                            <el-select v-model="metadataItem.predicateLower"
                                                :style="{ width: relationshipWidth }" class="s-3" placeholder="判断关系"
                                                :disabled="!canEdit" @change="changePredicateLower($event, index, j)">
                                                <el-option v-for="countItem in countSign" :key="countItem.id"
                                                    :label="countItem.name" :value="countItem.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label-width="10px"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.valueLower`"
                                            :rules="[{ required: true, message: '请输入值', trigger: 'change' }]">
                                            <el-input style="width:80px;" v-model="metadataItem.valueLower"
                                                placeholder="请输入" :disabled="!canEdit"></el-input>
                                        </el-form-item>
                                        <el-form-item label-width="10px"
                                            v-if="!(metadataItem.predicateLower == '1' || metadataItem.predicateLower == '2')"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.predicateUpper`"
                                            :rules="[{ required: true, message: '请选择判断关系', trigger: 'change' }]">
                                            <el-select v-model="metadataItem.predicateUpper"
                                                :style="{ width: relationshipWidth }" class="s-3" placeholder="判断关系"
                                                :disabled="!canEdit">
                                                <el-option v-for="item in countSign" :key="item.id" :label="item.name"
                                                    :value="item.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label-width="10px"
                                            v-if="!(metadataItem.predicateLower == '1' || metadataItem.predicateLower == '2')"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.valueUpper`"
                                            :rules="[{ required: true, message: '请输入值', trigger: 'change' }]">
                                            <el-input style="width:80px;" v-model="metadataItem.valueUpper"
                                                placeholder="请输入" :disabled="!canEdit"></el-input>
                                        </el-form-item>
                                    </template>
                                    <!-- 判断关系 -->
                                    <template v-if="metadataItem.dataType == 'D,S1' || metadataItem.dataType == 'S1'">
                                        <el-form-item label-width="10px"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.predicateLower`"
                                            :rules="[{ required: true, message: '请选择判断关系', trigger: 'change' }]">
                                            <el-select v-model="metadataItem.predicateLower"
                                                :style="{ width: relationshipWidth }" placeholder="判断关系"
                                                :disabled="!canEdit">
                                                <el-option v-for="item in enumContain" :key="item.id" :label="item.name"
                                                    :value="item.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <!-- 属性值 -->
                                        <el-form-item label-width="10px"
                                            :prop="`ruleInfoList.${index}.ruleMetadataInfoList.${j}.valueLower`"
                                            :rules="[{ required: true, message: '请选择值', trigger: 'change' }]">
                                            <el-select v-model="metadataItem.valueLower" style="width: 250px;"
                                                placeholder="请选择" filterable :reserve-keyword="false" multiple
                                                :disabled="!canEdit">
                                                <el-option v-for="(ele, eleIndex) in metadataItem.enumList"
                                                    :key="eleIndex" :label="ele" :value="ele">
                                                    <span style="float: left">{{ ele | getEleValue }}</span>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </template>
                            </div>
                            <el-button v-if="canEdit && item.ruleMetadataInfoList.length > 1"
                                style="margin-bottom: 15px;" type="text" icon="el-icon-delete"
                                @click="deleteRuleMetadataClick(index, j)"></el-button>
                        </div>
                    </div>
                    <!-- 添加属性按钮 -->
                    <el-form-item v-if="item.labelRuleCategoryId">
                        <el-button type="primary" text :disabled="!canEdit" @click="addRuleMetadataClick(index)">
                            添加属性
                        </el-button>
                    </el-form-item>
                    <!-- 属性规则逻辑 -->
                    <el-form-item label="属性规则逻辑" :prop="'ruleInfoList.' + index + '.expression'">
                        <el-input :id="`logicInput${index}`" v-model="item.expression" :rows="3" type="textarea"
                            placeholder="请输入属性规则逻辑，只有一个属性规则时不用写。示例：属性规则1 and 属性规则2 or（属性规则3 and 属性规则4）"
                            :disabled="!canEdit"></el-input>
                        <div class="rules-tips">
                            <div class="rules-tips-left">
                                <span>属性规则逻辑常见运算符：</span>
                                <el-button style="width: 56px;" @click="addSignToLogic('()', index)"
                                    :disabled="!canEdit" size="mini">()</el-button>
                                <el-button style="width: 56px;" @click="addSignToLogic('and', index)"
                                    :disabled="!canEdit" size="mini">and</el-button>
                                <el-button style="width: 56px;" @click="addSignToLogic('or', index)"
                                    :disabled="!canEdit" size="mini">or</el-button>
                            </div>
                            <div class="rules-tips-right">
                                <el-button style="width: 80px;" @click="checkLogic(index)" :disabled="!canEdit"
                                    size="mini">检查</el-button>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </div>
            <el-form-item>
                <el-button type="primary" text :disabled="!canEdit" @click="addRulesClick">
                    添加规则
                </el-button>
            </el-form-item>
            <!-- 总逻辑 -->
            <el-form-item label="总逻辑" prop="expression">
                <el-input id="logicInput" v-model="configurationRulesForm.expression" :rows="3" type="textarea"
                    placeholder="请输入规则逻辑，只有一个规则时不用写。示例：规则1 and 规则2 or（规则3 and 规则4）" :disabled="!canEdit"></el-input>
                <div class="rules-tips">
                    <div class="rules-tips-left">
                        <span>常见运算符：</span>
                        <el-button style="width: 56px;" @click="addSignToLogic('()')" :disabled="!canEdit"
                            size="mini">()</el-button>
                        <el-button style="width: 56px;" @click="addSignToLogic('and')" :disabled="!canEdit"
                            size="mini">and</el-button>
                        <el-button style="width: 56px;" @click="addSignToLogic('or')" :disabled="!canEdit"
                            size="mini">or</el-button>
                    </div>
                    <div class="rules-tips-right">
                        <el-button style="width: 80px;" @click="checkLogic(undefined)" :disabled="!canEdit"
                            size="mini">检查</el-button>
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button size="small" @click="configurationRulesVisible = false">取消</el-button>
            <el-button size="small" type="primary" :loading="isSave"
                @click="submitRules('addConfigurationRef')">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    getRuleDetailByLabelId,
    getLabelRuleCategoryList,
    getLabelRuleMetadataList,
    getS1AllValue,
    getS3AllValue,
    checkExpression,
    saveLabelRule,
    putLabelRule,
} from "../api/index";
import { DEEP_CLONE } from "@/utils/constants";
// 默认属性信息
const defaultRuleInfo = {
    ruleKeyName: '', // 属性规则key
    metadataId: '', // 属性id
    metadataName: '', // 属性名称
    sqlField: '',
    dataType: '', // 属性类型
    timeType: '', // 时间轴类型
    recent: '', // 近多少天
    time: [], // 时间
    predicateLower: '', // 数值型下限
    valueLower: '', // 数值型下限值
    predicateUpper: '', // 数值型上限
    valueUpper: '', // 数值型上限值
    enumList: [], // 枚举值列表
}
export default {
    data() {
        return {
            // 配置规则弹框是否显示
            configurationRulesVisible: false,
            selectRuleList: [],
            isIndeterminate: false,
            checkAll: false,
            // 配置规则数据
            configurationRulesForm: {
                labelId: '', // 标签id
                unbind: 1, // 不符合标签的患者
                method: 2, // 是否自动更新
                // 规则列表
                ruleInfoList: [
                    {
                        key: new Date().getTime(),
                        labelId: '', // 标签id
                        name: '', // 规则名称
                        labelRuleCategoryId: '', // 规则属性id
                        expression: '', // 规则逻辑
                        // 后端返回的 属性值列表（保存数据的时候不需要传给后端）
                        ruleMetadataList: [],
                        // 规则属性值列表
                        ruleMetadataInfoList: [
                            Object.assign({}, defaultRuleInfo),
                        ],
                    },
                ],
                // 总规则逻辑
                expression: '',
            },
            // 配置规则 rule
            configurationRulesRules: {
                unbind: [{ required: true, message: "请选择不符合标签的患者", trigger: ["change"] }],
                method: [{ required: true, message: "请选择是否自动更新", trigger: ["change"] }],
                // expression: [{ required: true, message: "请输入规则逻辑", trigger: ["blur"] }],
            },
            canEdit: true,
            // 规则属性列表
            rulePropertyList: [],
            relationshipWidth: '120px',
            isSave: false,
            countSign: [
                {
                    id: 1,
                    name: '等于'
                },
                {
                    id: 2,
                    name: '不等于'
                },
                {
                    id: 3,
                    name: '小于'
                },
                {
                    id: 4,
                    name: '小于等于'
                },
                {
                    id: 5,
                    name: '大于'
                },
                {
                    id: 6,
                    name: '大于等于'
                }
            ],
            enumSign: [
                {
                    id: 7,
                    name: '选择'
                },
                {
                    id: 8,
                    name: '不选择'
                }
            ],
            enumContain: [
                {
                    id: 9,
                    name: '包含'
                },
                {
                    id: 10,
                    name: '不包含'
                }
            ],
            metadataValueListBoolean: [
                {
                    id: '0',
                    name: '否'
                },
                {
                    id: '1',
                    name: '是'
                }
            ],
            timeAxis: [
                {
                    id: 1,
                    name: '绝对时间'
                },
                {
                    id: 2,
                    name: '相对时间'
                }
            ],
        };
    },
    filters: {
        getEleValue(value) {
            if (value && value.length > 25) {
                return value.substring(0, 24) + '...'
            }
            return value
        },
    },
    created() { },
    methods: {
        // 配置规则弹框显示
        openDialog(row) {
            this.configurationRulesForm.labelId = row.id
            this.selectRuleList = []
            this.isIndeterminate = false
            this.checkAll = false
            getRuleDetailByLabelId({
                labelId: row.id,
            }).then(res => {
                if (res.data) {
                    this.canEdit = false
                    this.configurationRulesForm = res.data
                    this.configurationRulesForm.ruleInfoList.forEach(item => {
                        var ruleMetadataList = []
                        item.ruleMetadataInfoList.forEach((metadataItem, j) => {
                            metadataItem.ruleKeyName = `属性值${j + 1}`
                            ruleMetadataList.push({
                                id: metadataItem.metadataId,
                                name: metadataItem.metadataName,
                            })
                            const dataType = metadataItem.dataType
                            if (dataType == 'D,S1' || dataType.includes('S1')) {
                                metadataItem.valueLower = metadataItem.valueLower.split(',')
                            }
                            if (dataType.includes('S3')) {
                                metadataItem.valueLower = metadataItem.valueNameList
                            }
                            if (dataType.includes('D') && metadataItem.timeType == 1) {
                                metadataItem.time = [metadataItem.timeStart, metadataItem.timeEnd]
                            }
                        })
                        item.ruleMetadataList = ruleMetadataList
                    })
                } else {
                    this.canEdit = true
                    this.configurationRulesForm = {
                        labelId: row.id, // 标签id
                        unbind: 1, // 不符合标签的患者
                        method: 2, // 是否自动更新
                        // 规则列表
                        ruleInfoList: [
                            {
                                key: new Date().getTime(),
                                labelId: '', // 标签id
                                name: '', // 规则名称
                                labelRuleCategoryId: '', // 规则属性id
                                expression: '', // 规则逻辑
                                // 后端返回的 属性值列表（保存数据的时候不需要传给后端）
                                ruleMetadataList: [],
                                // 规则属性值列表
                                ruleMetadataInfoList: [
                                    Object.assign({}, defaultRuleInfo),
                                ],
                            },
                        ],
                        // 总规则逻辑
                        expression: '',
                    }
                }
                this.configurationRulesVisible = true
            })
            // 获取规则属性列表
            getLabelRuleCategoryList({
                name: '',
            }).then(res => {
                this.rulePropertyList = res.data
            })
        },
        // 全选
        handleCheckAllChange(value) {
            var list = []
            if (value) {
                this.configurationRulesForm.ruleInfoList.forEach(item => {
                    list.push(item.key)
                })
            }
            this.selectRuleList = list
            this.isIndeterminate = false
        },
        // 批量删除
        handleDeleteClick() {
            if (this.selectRuleList.length <= 0) {
                this.$message.success('至少选择一个规则')
                return
            }
            if (this.selectRuleList.length >= this.configurationRulesForm.ruleInfoList.length) {
                this.$message.error('至少需保留一个规则')
                return
            }
            this.$confirm('确定要删除规则吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                customClass: 'message-confirm',
            }).then(() => {
                const diff = this.configurationRulesForm.ruleInfoList.filter(obj1 => !this.selectRuleList.some(obj2 => obj1.key === obj2))
                this.configurationRulesForm.ruleInfoList = diff
                this.selectRuleList = []
                this.handleIndeterminateChange()
            });
        },
        // 复制
        handleCopyClick() {
            if (this.selectRuleList.length <= 0) {
                this.$message.success('至少选择一个规则')
                return
            }
            const length = this.configurationRulesForm.ruleInfoList.length
            const diff = this.configurationRulesForm.ruleInfoList.filter(obj1 => this.selectRuleList.some(obj2 => obj1.key === obj2))
            const list = DEEP_CLONE(diff)
            list.forEach(item => {
                let key = new Date().getTime()
                item.key = key
                item.name = item.name + '复制'
            })
            this.configurationRulesForm.ruleInfoList = this.configurationRulesForm.ruleInfoList.concat(list)
            this.handleIndeterminateChange()
            // 滚动到粘贴的第一个规则
            this.$nextTick(() => {
                const target = document.getElementById(`ruleInfo${length}`)
                if (target) {
                    // 如果scrollIntoView满足需求，可以直接使用  
                    target.scrollIntoView({ behavior: 'smooth' })

                    // 或者，如果需要更精细的控制，可以这样做  
                    // const container = this.$refs.scrollContainer
                    // container.scrollTop = target.offsetTop - container.offsetTop // 可能需要调整以考虑其他因素，如padding  
                }
            })
        },
        handleCheckChange(value, item) {
            if (value) {
                this.selectRuleList.push(item.key)
            } else {
                this.selectRuleList = this.selectRuleList.filter(item1 => item1 != item.key)
            }
            this.handleIndeterminateChange()
        },
        handleIndeterminateChange() {
            let length = this.selectRuleList.length
            let total = this.configurationRulesForm.ruleInfoList.length
            this.checkAll = (length == total)
            this.isIndeterminate = (length > 0 && length < total)
        },
        // 规则属性变化回调
        ruleCategoryChange(value, index) {
            // 需要清空属性列表
            var info = DEEP_CLONE(defaultRuleInfo)
            info.ruleKeyName = '属性值1'
            this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList = [
                info,
            ]
            // 获取规则属性下 属性值列表
            getLabelRuleMetadataList({
                categoryId: value,
            }).then(res => {
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataList = res.data
            })
        },
        // 属性值变化回调
        ruleMetadataChange(value, index, j) {
            var chooseItem
            this.configurationRulesForm.ruleInfoList[index].ruleMetadataList.forEach(item => {
                if (item.id == value) {
                    chooseItem = item
                }
            })

            if (chooseItem && chooseItem.dataType) {
                // 需要把之前选择的清空
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].timeType = ''
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].recent = ''
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].time = []

                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].predicateLower = ''
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].valueLower = ''
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].predicateUpper = ''
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].valueUpper = ''
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].enumList = []

                let dataType = chooseItem.dataType;
                // 日期+字符串/字符串类型
                if (dataType == 'D,S1' || dataType.includes('S1')) {
                    this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].valueLower = []
                    this.fetchEnumListAttr(chooseItem, index, j)
                } else if (dataType.includes('S3')) {
                    // 枚举值类型
                    this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].valueLower = []
                    this.fetchEnumList(chooseItem.enumCode, index, j)
                }
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].metadataName = chooseItem.name
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].sqlField = chooseItem.sqlField
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].dataType = dataType
            }
        },
        // 时间类型变化回调
        changeTimeType(value, index, j) {
            this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].recent = '';
            this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].time = [];
        },
        changePredicateLower(value, index, j) {
            // 如果选择了等于或者不等于，清空上限值
            if (value == 1 || value == 2) {
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].predicateUpper = '';
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].valueUpper = '';
            }
        },
        // 添加规则
        addRulesClick() {
            this.configurationRulesForm.ruleInfoList.push({
                key: new Date().getTime(),
                labelId: '', // 标签id
                name: '', // 规则名称
                labelRuleCategoryId: '', // 规则属性id
                expression: '', // 规则逻辑
                // 后端返回的 属性值列表（保存数据的时候不需要传给后端）
                ruleMetadataList: [],
                // 规则属性值列表
                ruleMetadataInfoList: [
                    Object.assign({}, defaultRuleInfo),
                ],
            })
            this.handleIndeterminateChange()
        },
        // 删除规则
        deleteRulesClick(index, item) {
            // 需要把选中的规则也删除
            this.selectRuleList = this.selectRuleList.filter(item1 => item1 != item.key)
            this.configurationRulesForm.ruleInfoList.splice(index, 1)
            this.handleIndeterminateChange()
        },
        // 添加属性
        addRuleMetadataClick(index) {
            if (!this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList) {
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList = []
            }
            const length = this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList.length + 1
            var info = Object.assign({}, defaultRuleInfo)
            info.ruleKeyName = `属性值${length}`
            this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList.push(
                info,
            )
        },
        // 删除属性
        deleteRuleMetadataClick(index, j) {
            this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList.splice(j, 1)
            // 删除属性后，ruleKeyName 需要重新赋值
            this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList.forEach((item, z) => {
                item.ruleKeyName = `属性值${z + 1}`
            })
        },
        addSignToLogic1(item) {
            let name = item.name
            if (!name) {
                this.$message.error('请输入规则名称')
                return
            }
            this.addSignToLogic(`${name} `)
        },
        addSignToLogic(newValue, index) {
            if (!this.canEdit) {
                return
            }
            if (index != undefined) {
                let currentValue = this.configurationRulesForm.ruleInfoList[index].expression
                let id = `logicInput${index}`
                this.configurationRulesForm.ruleInfoList[index].expression = this.insertSpecifiedPosition(id, currentValue, newValue)
            } else {
                this.configurationRulesForm.expression = this.insertSpecifiedPosition('logicInput', this.configurationRulesForm.expression, newValue)
            }
        },
        // 检查
        checkLogic(index) {
            var expression
            var rules
            if (index != undefined) {
                const ruleInfo = this.configurationRulesForm.ruleInfoList[index]
                // 属性列表
                const ruleMetadataInfoList = ruleInfo.ruleMetadataInfoList
                if (ruleMetadataInfoList.length == 1 && !ruleMetadataInfoList[0].ruleKeyName) {
                    this.$message.error('请输入属性值名称');
                    return;
                }
                // 如果属性列表只有一个，就取第一个属性列表的值
                // 如果属性列表有多个，就取外层输入框的值
                expression = (ruleMetadataInfoList.length == 1 ? ruleMetadataInfoList[0].ruleKeyName : ruleInfo.expression)
                rules = ruleMetadataInfoList.map(v => v.ruleKeyName)
            } else {
                const ruleInfoList = this.configurationRulesForm.ruleInfoList
                if (ruleInfoList.length == 1 && !ruleInfoList[0].name) {
                    this.$message.error('请输入规则名称');
                    return;
                }
                expression = (ruleInfoList.length == 1 ? ruleInfoList[0].name : this.configurationRulesForm.expression)
                rules = ruleInfoList.map(v => v.name)
            }
            const params = {
                expression: expression,
                rules: rules,
            };
            checkExpression(params).then(res => {
                this.$message.success('检查成功')
            })
        },
        insertSpecifiedPosition(id, currentValue, newValue) {
            const questionInput = document.getElementById(id)
            // 设置光标起始位置
            let startPos = questionInput.selectionStart
            let endPos = questionInput.selectionEnd

            const newValue1 = currentValue.slice(0, startPos) + newValue + currentValue.slice(endPos)
            // 提前得到更新后的光标位置
            this.$nextTick(() => {
                questionInput.selectionStart = startPos + newValue.length
                questionInput.selectionEnd = startPos + newValue.length
            });
            questionInput.focus();
            return newValue1;
        },
        fetchEnumListAttr(chooseItem, index, j) {
            var params = {
                id: chooseItem.id,
            }
            if (chooseItem.labelRuleCategoryId == '4' && (chooseItem.id == '13' || chooseItem.id == '14')) {
                // labelRuleCategoryId == '4' 表示 量表收集 规则属性
                // id == '13' 表示 量表收集 规则属性下面的 题目名称 属性值
                // id == '14' 表示 量表收集 规则属性下面的 题目答案 属性值
                var queryParamList = []
                const ruleMetadataInfoList = this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList
                ruleMetadataInfoList.forEach(item => {
                    if (item.metadataId == '12' && item.predicateLower == 9) {
                        // 问卷名称而且包含
                        queryParamList.push({
                            columnName: item.sqlField,
                            columnValue: item.valueLower.join(','),
                        })
                    }
                    if (chooseItem.id == '14' && item.metadataId == '13' && item.predicateLower == 9) {
                        // 题目名称而且包含
                        queryParamList.push({
                            columnName: item.sqlField,
                            columnValue: item.valueLower.join(','),
                        })
                    }
                })
                params.queryParamList = queryParamList
            }
            getS1AllValue(params).then(res => {
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].enumList = res.data
            })
        },
        fetchEnumList(code, index, j) {
            getS3AllValue({
                name: '',
                code,
            }).then(res => {
                this.configurationRulesForm.ruleInfoList[index].ruleMetadataInfoList[j].enumList = res.data
            })
        },
        submitRules(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isSave = true
                    let formData = DEEP_CLONE(this.configurationRulesForm)
                    if (formData.id) {
                        // 编辑
                        putLabelRule({
                            id: formData.id,
                            method: formData.method,
                            unbind: formData.unbind,
                        }).then(res => {
                            this.$message.success('编辑成功')
                            this.configurationRulesVisible = false
                        })
                        return
                    }
                    // 如果规则只有一个，总逻辑就是第一个规则的名字
                    if (formData.ruleInfoList && formData.ruleInfoList.length == 1) {
                        formData.expression = formData.ruleInfoList[0].name
                    }
                    // 规则列表遍历
                    formData.ruleInfoList.forEach(item => {
                        item.labelId = formData.labelId
                        // 删除后端返回的属性列表数据
                        delete item.ruleMetadataList
                        // 如果属性只有一个，属性逻辑就是第一个属性的名字
                        if (item.ruleMetadataInfoList && item.ruleMetadataInfoList.length == 1) {
                            item.expression = item.ruleMetadataInfoList[0].ruleKeyName
                        }
                        // 属性列表遍历
                        item.ruleMetadataInfoList.forEach(metadataItem => {
                            delete metadataItem.enumList
                            let valueLower = metadataItem.valueLower
                            if (valueLower && Array.isArray(valueLower)) {
                                valueLower = metadataItem.valueLower.join(',')
                            }
                            metadataItem.valueLower = valueLower

                            // 时间
                            if (metadataItem.time && metadataItem.time.length > 0) {
                                metadataItem.timeStart = metadataItem.time[0]
                                metadataItem.timeEnd = metadataItem.time[1]
                            }
                        })
                    })
                    saveLabelRule(formData).then(res => {
                        this.isSave = false
                        this.$message.success('保存成功')
                        this.configurationRulesVisible = false
                    }).catch(e => {
                        this.isSave = false
                    })
                } else {
                    return false;
                }
            });
        },
    }
};
</script>

<style lang="less" scoped>
.rules-select-all {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.rules-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 5px;

    .dashed-line {
        flex-grow: 1;
        margin-left: 10px;
        margin-right: 10px;
        height: 1px;
        border: 1px dashed #E9E9E9;
    }
}

.rules-item {
    background: #fafafa;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    margin-bottom: 20px;
    border-radius: 10px;
}

.rules-content {
    background: #f0f0f0;
    padding-top: 10px;
    padding-right: 10px;
    margin-bottom: 20px;

    .rules-content-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
}

.rules-textarea {
    margin-top: 30px;
}

.rules-tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9px 0;
    border: 1px solid #d9d9d9;
    border-top: none;

    .rules-tips-left {
        margin-left: 20px;
    }

    .rules-tips-right {
        margin-right: 20px;
    }
}
</style>
